import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import FocusLock from "react-focus-lock";
import classnames from "classnames";
import Button from "../Button/Button";
import { IconClose16 } from "../Icons/Icons";
import "./modal.scss";

class Modal extends Component {
  constructor(props) {
    super(props);
    this.handleOnEscape = this.handleOnEscape.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleOnEscape, false);
    document.body.classList.toggle("modal-open");
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleOnEscape);
    document.body.classList.remove("modal-open");
  }

  handleOnEscape(e) {
    const { closeModal } = this.props;
    if (e.keyCode === 27) {
      closeModal();
    }
  }

  render() {
    const {
      children,
      closeModal,
      buttonLeft,
      buttonRight,
      closeLinkText,
      containerRef,
      role,
      fullScreen,
      className,
    } = this.props;
    const hasActions = buttonLeft || buttonRight;

    const classes = classnames(
      "modal",
      {
        "modal--has-actions": hasActions,
        "modal--full-screen": fullScreen,
      },
      className
    );

    return (
      <Fragment>
        <button
          type="button"
          tabIndex="-1"
          className="modal-overlay"
          onClick={closeModal}
          text={closeLinkText}
          aria-label="Close Modal"
        />
        <div className="modal-container">
          <div className="modal__outer" ref={containerRef}>
            <div className={classes} aria-modal="true" role={role}>
              <FocusLock returnFocus className="modal__inner">
                {closeLinkText && (
                  <div className="modal__close-bar">
                    <Button
                      text={closeLinkText}
                      icon={IconClose16}
                      iconPosition="right"
                      variant="link"
                      className="modal__close"
                      onClick={closeModal}
                      aria-label="Close Modal"
                    />
                  </div>
                )}
                <div className="modal__content">{children}</div>

                {hasActions && (
                  <div className="modal__actions">
                    {buttonLeft && <div className="modal__action--left">{buttonLeft}</div>}
                    {buttonRight && <div className="modal__action--right">{buttonRight}</div>}
                  </div>
                )}
              </FocusLock>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

Modal.defaultProps = {
  role: "dialog",
};

Modal.propTypes = {
  closeModal: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  buttonLeft: PropTypes.node,
  buttonRight: PropTypes.node,
  closeLinkText: PropTypes.string,
  containerRef: PropTypes.shape({}),
  role: PropTypes.string,
  fullScreen: PropTypes.bool,
  className: PropTypes.string,
};
export default Modal;
